import script from "./NotFound.vue?vue&type=script&setup=true&lang=js"
export * from "./NotFound.vue?vue&type=script&setup=true&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=43a3ed26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43a3ed26"]])

export default __exports__